import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CardFormComponent } from '../../../card-form/card-form.component';
import { SupplierActivityFormComponent } from '../activity-form/activity-form.component';
import { SupplierFeatureFormComponent } from '../feature-form/feature-form.component';
import { DeleteAttendeeWarningComponent } from '../../../delete-attendee-warning/delete-attendee-warning.component';
import { PayBalanceComponent } from '../../../pay-balance/pay-balance.component';
import { MdDialog, MdSnackBar, MdDialogRef, MdSnackBarConfig } from '@angular/material';
import { EventService } from '../../../admin/event.service';
import { UserService } from '../../../common/user.service';
import { PageService } from '../../../common/page.service';
import { PackageService } from '../../../common/package.service';
import { FeatureService } from '../../../common/feature.service';
import { CardService } from '../../../common/card.service';
import { SupplierAttendeeFormComponent } from '../attendee-form/attendee-form.component';
import { EditSupplierAttendeeComponent } from '../edit-attendee/edit-attendee.component';
import { EditTravelComponent } from '../../../edit-travel/edit-travel.component';
import { ChangeAdminPasswordComponent } from '../../../admin/profile/change-password/change-admin-password.component';
import { AuthenticationService } from '../../../auth/authentication.service';
import { Router } from '@angular/router';
import { AppSettings } from '../../../app-settings'


@Component({
  selector: 'supplier-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css', '../../../app.component.css'],
  providers: [EventService, UserService, PackageService, CardService, FeatureService, PageService]
})
export class SupplierProfileComponent implements OnInit {

  public userInfo = JSON.parse(localStorage.userInfo);
  public users = [];
  public events = [];
  public eventId = 0;
  public event: any;
  public package: any;
  public cards = [];
  public spinner: boolean = false;
  public errorMessage: any;
  public profile: any;
  public balanceDue: any = 0;
  public features = [];
  public freeFeatures = [];
  public eventPages = [];
  public selectedTab = 0;

  CONTACT_EMAIL = AppSettings.CONTACT_EMAIL
  CONTACT_NAME = AppSettings.CONTACT_NAME

  constructor(public dialog: MdDialog, private eventService: EventService, private userService: UserService, private titleService: Title, private packageService: PackageService, private cardService: CardService, private snackBar: MdSnackBar, public auth: AuthenticationService, private router: Router, private featureService: FeatureService, private pageService: PageService) {
    this.dialog.afterAllClosed.subscribe(() => {
      this.getEvents();
    });
  }

  ngOnInit() {
    this.titleService.setTitle('Supplier Profile');
    this.getEvents();
    this.getCards();
    this.getPages();
  }

  getPages() {
    this.pageService.getPages(this.eventId).subscribe(response => {
      this.eventPages = response;
      var pages = [];
      for (var i = 0; i < this.eventPages.length; i++)
        if (this.eventPages[i].displayFor == 'Suppliers' || this.eventPages[i].displayFor == 'Both')
          pages.push(this.eventPages[i]);
      this.eventPages = pages;
    });
  }

  getEvents() {
    this.eventService.getEvents({}).subscribe(response => {
      this.events = response;
      for (var i = 0; i < this.events.length; i++) {
              this.events[i].id = parseInt(this.events[i].id);
              this.events[i].reg_ended = parseInt(this.events[i].reg_ended);
              this.events[i].obtainTravel = parseInt(this.events[i].obtainTravel);
              if(this.events[i].isCurrentEvent==1){
                this.eventId=parseInt(this.events[i].id);
              }
      }
      this.eventSelected();
    });
  }

  getCards() {
    this.spinner = true;
    this.cardService.getCards(this.userInfo.userId).subscribe(
      response => {
        this.spinner = false;
        this.cards = response;
      },
      error => {
        this.spinner = false;
      }
    );
  }

  phoneFormat(phone) {
    if (phone && phone != '')
      return (phone).replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }

  cardFormDialog(card) {
    let dialogRef = this.dialog.open(CardFormComponent);
    dialogRef.componentInstance.users = this.users[0];
    if (card)
      dialogRef.componentInstance.creditCard = card;
    else
      dialogRef.componentInstance.creditCard = '';
    dialogRef.componentInstance.onSave.subscribe(() => {
      this.getCards();
      dialogRef.close();
    });
  }

  activityFormDialog(params) {
    let dialogRef = this.dialog.open(SupplierActivityFormComponent);
    dialogRef.componentInstance.eventId = this.eventId;
    dialogRef.componentInstance.packageId = this.package.id;
    dialogRef.componentInstance.users = this.users;
    dialogRef.componentInstance.event = this.event;
    dialogRef.componentInstance.cards = this.cards;
    dialogRef.componentInstance.creditCard.existing = (this.cards.length > 0 ? true : false);
    dialogRef.componentInstance.userIndex = params.userIndex;
    dialogRef.componentInstance.balance = (this.balanceDue) ? this.balanceDue : 0;
    dialogRef.componentInstance.currentActivity = dialogRef.componentInstance.users[params.userIndex].eventUser.userActivity.activityId;
    dialogRef.componentInstance.initiate();
    dialogRef.componentInstance.onSave.subscribe(() => {
      this.getEvents();
      this.getCards();
      dialogRef.close();
    });
    dialogRef.componentInstance.onClose.subscribe(() => {
      this.getEvents();
      dialogRef.close();
    });
  }

  featureFormDialog(params) {
    let dialogRef = this.dialog.open(SupplierFeatureFormComponent);
    dialogRef.componentInstance.eventId = this.eventId;
    dialogRef.componentInstance.packageId = this.package.id;
    dialogRef.componentInstance.users = this.users;
    dialogRef.componentInstance.balance = (this.balanceDue) ? this.balanceDue : 0;

    var oldUserFeatures = [];
    this.users[params.userIndex].eventUser.userFeatures.forEach(function(userFeature) {
      oldUserFeatures[userFeature.id] = { price: userFeature.price };
    });
    dialogRef.componentInstance.oldUserFeatures = oldUserFeatures;
    dialogRef.componentInstance.oldPrice = dialogRef.componentInstance.featurePriceFloat();
    var featurePrice = 0;
    for (var i = 0; i < this.users.length; i++)
      for (var j = 0; j < this.users[i].eventUser.userFeatures.length; j++)
        featurePrice += parseInt(this.users[i].eventUser.userFeatures[j].price);
    dialogRef.componentInstance.event = this.event;
    dialogRef.componentInstance.cards = this.cards;
    dialogRef.componentInstance.creditCard.existing = (this.cards.length > 0 ? true : false);
    dialogRef.componentInstance.userIndex = params.userIndex;
    for (var i = 0; i < dialogRef.componentInstance.users[params.userIndex].eventUser.userFeatures.length; i++) {
      dialogRef.componentInstance.currentAnswerTexts[i] = dialogRef.componentInstance.users[params.userIndex].eventUser.userFeatures[i].answerText;
      dialogRef.componentInstance.currentAnswerIds[i] = dialogRef.componentInstance.users[params.userIndex].eventUser.userFeatures[i].answerId;
    }
    dialogRef.componentInstance.initiate();
    dialogRef.componentInstance.onSave.subscribe(() => {
      this.getEvents();
      this.getCards();
      dialogRef.close();
    });
    dialogRef.componentInstance.onClose.subscribe(() => {
      this.getEvents();
      this.getCards();
      dialogRef.close();
    });
  }

  deleteAttendeeWarningDialog() {
    let dialogRef = this.dialog.open(DeleteAttendeeWarningComponent);
  }

  payBalanceDialog() {
    let dialogRef = this.dialog.open(PayBalanceComponent);
  }

  eventSelected() {
    this.spinner = true;
    this.users = [];
    this.package = undefined;
    for (var i = 0; i < this.events.length; i++)
      if (this.events[i].id == this.eventId) {
        this.event = this.events[i];
        break;
      }
    this.userService.supplierProfile({ userId: this.userInfo.userId, eventId: this.eventId, eventUserId: this.userInfo.eventUserId }).subscribe(
      response => {
        this.spinner = false;
        this.users = response.users;
        this.profile = response;
        this.balanceDue = (response.bal) ? response.bal : 0;
        if (this.users[0].eventUser)
          this.packageService.findPackage(this.users[0].eventUser.packageId).subscribe(response => {
            this.package = response[0];
            this.featureService.getFeaturesWithOptions(this.eventId).subscribe(response => {
              this.features = response;
              this.packageService.getFeatureLimits({ packageId: this.package.id }).subscribe(response => {
                this.freeFeatures = [];
                for (var i = 0; i < response.length; i++)
                  if (parseInt(response[i].free))
                    this.freeFeatures.push(response[i]);
              });
            });
          });
      },
      error => {
        this.spinner = false;
      }
    );
    this.getPages();
  }

  usDateTimeFormat(dt) {
    if (dt) {
      if (typeof dt == 'string') {
        dt = dt.split(' ');
        dt = dt[0].split('-');
        if(dt[1]>0)
          return dt[1] + '/' + dt[2] + '/' + dt[0];
        else
          return ''
      }
      else {
        var m = dt.getMonth() + 1;
        if (m < 10)
          m = '0' + m;
        var d = dt.getDate();
        if (d < 10)
          d = '0' + d;
        return m + '/' + d + '/' + dt.getFullYear();
      }
    }
    else
      return '';
  }

  //formatAMPM(date) {
  //  date = new Date(date);
  //  var hours = date.getHours();
  //  var minutes = date.getMinutes();
  //  var ampm = hours >= 12 ? 'pm' : 'am';
  //  hours = hours % 12;
  //  hours = hours ? hours : 12; // the hour '0' should be '12'
  //  minutes = minutes < 10 ? '0' + minutes : minutes;
  //  var strTime = hours + ':' + minutes + ' ' + ampm;
  //  return strTime;
  //}

  formatAMPM(dt) {
    //date = new Date(date);
    //var hours = date.getHours();
    //var minutes = date.getMinutes();
    //var ampm = hours >= 12 ? 'pm' : 'am';
    //hours = hours % 12;
    //hours = hours ? hours : 12; // the hour '0' should be '12'
    //if(minutes)
    //  minutes = minutes < 10 ? ('00'+(minutes)).slice(-2) : minutes;
    //else
    //  minutes='00';
    //var strTime = hours + ':' + minutes + ' ' + ampm;
    //return strTime;

    if (dt) {
      if (typeof dt == 'string') {
        dt = dt.split(' ');
        dt = dt[1].split(':');

        var ampm = dt[0] >= 12 ? 'pm' : 'am';
        var hours = (dt[0]>0)?((dt[0]==12) ? dt[0] : dt[0] % 12):((dt[0]==0)?12:0);
        if(hours==12){
          hours = hours % 12;
          hours = hours ? hours : 12;
        }
        var minutes=dt[1];
        minutes = minutes < 10 ? ('00'+(minutes)).slice(-2) : minutes;
        if(hours>0)
          var strTime = hours + ':' + minutes + ' ' + ampm;
        else
          var strTime = '';

        return strTime;
      }

    }
    else
      return '';

  }
  getFinalTotal() {
    if (this.users[0].eventUser.totalPrice > 0) {
      var fTotal: any = 0;
      fTotal = parseFloat(this.users[0].eventUser.totalPrice) - (parseFloat(this.users[0].eventUser.discount) + parseFloat(this.profile.refundAmount[0].refundAmount));
      return (fTotal > 0) ? fTotal : 0;
    }
    return 0;
  }

  attendeeFormDialog() {
    let addAttendee: MdDialogRef<SupplierAttendeeFormComponent>;
    addAttendee = this.dialog.open(SupplierAttendeeFormComponent);
    addAttendee.componentInstance.userId = this.userInfo.userId;
    addAttendee.componentInstance.eventId = this.eventId;
    addAttendee.componentInstance.userType = this.userInfo.type;
    addAttendee.componentInstance.eventUserId = this.userInfo.eventUserId;
    addAttendee.componentInstance.balance = (this.balanceDue) ? this.balanceDue : 0;

    addAttendee.componentInstance.mainUser = this.users[0];
    addAttendee.afterClosed()
      .subscribe(
        response => {
          if (response) {
            this.getEvents();
            this.getCards();
          }
        },
        error => {
          this.errorMessage = <any>error;
        }
      );
  }

  editAttendee(userId, counts) {
    let editAttendee: MdDialogRef<EditSupplierAttendeeComponent>;
    editAttendee = this.dialog.open(EditSupplierAttendeeComponent);
    editAttendee.componentInstance.userId = userId;
    editAttendee.componentInstance.eventId = this.eventId;
    editAttendee.componentInstance.eventUserId = this.userInfo.eventUserId;
    editAttendee.componentInstance.counts = counts;
    editAttendee.afterClosed()
      .subscribe(
        response => {
          if (response == true) {
            this.getEvents();
            this.getCards();
            this.userInfo = JSON.parse(localStorage.userInfo);
          }
        },
        error => {
          this.errorMessage = <any>error;
        }
      );
  }

  editTravelInfo(info) {
    let editTravel: MdDialogRef<EditTravelComponent>;
    editTravel = this.dialog.open(EditTravelComponent);
    editTravel.componentInstance.Info = info;
    editTravel.componentInstance.type = 'Supplier';
    editTravel.componentInstance.users = this.users;
    editTravel.componentInstance.eventId = this.eventId;
    editTravel.componentInstance.userId = this.userInfo.userId;
    editTravel.componentInstance.balance = (this.balanceDue) ? this.balanceDue : 0;
    editTravel.afterClosed()
      .subscribe(
        response => {
          if (response) {
            this.getEvents();
            this.getCards();
          }
        },
        error => {
          this.errorMessage = <any>error;
        }
      );
  }

  deleteCard(card) {
    if (confirm('Are you sure?')) {
      this.spinner = true;
      this.cardService.deleteCard(card).subscribe(
        response => {
          this.spinner = false;
          this.snackBar.open('Card deleted successfully', '', { duration: 4000 });
          this.getCards();
        },
        error => {
          this.spinner = false;
          this.snackBar.open(error, '', { duration: 4000 });
        }
      );
    }
  }

  getBalance() {
    //var totalAmt:any =0;
    //var balance:any =0;
    //
    //totalAmt=parseFloat(this.users[0].eventUser.totalPrice)-(parseFloat(this.profile.refundAmount[0].refundAmount)+(parseFloat(this.users[0].eventUser.discount)-parseFloat(this.profile.disRAmount[0].disRAmount)));
    //if(this.profile.dummyRefund[0].dummyRefund>0){
    //    balance=(totalAmt+(parseFloat(this.profile.refundAmount[0].refundAmount)-parseFloat(this.profile.dummyRefund[0].dummyRefund)))-(parseFloat(this.profile.cardPaid[0].total)+parseFloat(this.profile.checkPaid[0].total));
    //}else{
    //    balance=(totalAmt+(parseFloat(this.profile.refundAmount[0].refundAmount)))-(parseFloat(this.profile.cardPaid[0].total)+parseFloat(this.profile.checkPaid[0].total));
    //}
    //if(balance<0){
    //    balance= parseFloat(this.users[0].eventUser.totalPrice)-(parseFloat(this.profile.cardPaid[0].total)+parseFloat(this.profile.checkPaid[0].total)+parseFloat(this.profile.dummyRefund[0].dummyRefund))
    //}
    //(balance>0)?balance:0;
    //this.balanceDue=(balance).toFixed(2);
    //return (balance).toFixed(2);
  }

  payBalance(userId, eventId, type) {
    let payBalance: MdDialogRef<PayBalanceComponent>;
    payBalance = this.dialog.open(PayBalanceComponent);

    payBalance.componentInstance.userId = userId;
    payBalance.componentInstance.eventId = eventId;
    payBalance.componentInstance.type = type;
    payBalance.componentInstance.balance = (this.balanceDue) ? this.balanceDue : 0;
    payBalance.componentInstance.oldCards = this.cards;
    payBalance.componentInstance.mainUser = this.users[0];
    payBalance.componentInstance.eventUserId = this.userInfo.eventUserId;
    payBalance.componentInstance.totalBalance = (this.users[0].eventUser.totalPrice) ? this.users[0].eventUser.totalPrice : 0;


    payBalance.afterClosed()
      .subscribe(
        response => {
          if (response.status) {
            this.snackBar.open(response.message, '', <MdSnackBarConfig>{ duration: 4000 });
            //setTimeout(()=>{ window.location.reload();}, 2000)
            this.getEvents();
            this.getCards();
          }
        },
        error => {
          this.errorMessage = <any>error;
        }
      );
  }

  changePasswordDialog() {
    let dialogRef = this.dialog.open(ChangeAdminPasswordComponent);
    dialogRef.componentInstance.onChangePassword.subscribe(() => {
      dialogRef.close();
      this.logout();
    });
  }

  logout() {
    this.spinner = true;
    localStorage.removeItem('eventId');
    this.auth.logout().subscribe(
      response => {
        this.spinner = false;
        if (response === true)
          this.router.navigate(['/home']);
      },
      error => {
        this.spinner = false;
      }
    );
  }

  classExists(cT) {
    var cardClasses = ['mastercard', 'Mastercard', 'visa', 'Visa', 'american', 'American', 'american-express', 'amex', 'Amex', 'cirrus', 'Cirrus', 'dankort', 'Dankort', 'dinners', 'Dinners', 'discover', 'Discover', 'electron', 'Electron', 'jcb', 'Jcb', 'maestro', 'Maestro', 'paypal', 'Paypal', 'unionpay', 'Unionpay'];
    return (cardClasses.indexOf(cT) >= 0) ? true : false;
  }

  activeFeatures(userIndex) {
    var actFtr = [];
    for (var i = 0; i < this.users[userIndex].eventUser.userFeatures.length; i++)
      if (this.users[userIndex].eventUser.userFeatures[i].price > 0 || this.users[userIndex].eventUser.userFeatures[i].free)
        actFtr.push(this.users[userIndex].eventUser.userFeatures[i]);
    return actFtr;
  }

  activeFeaturesCount(userIndex) {
    var actFtr = this.activeFeatures(userIndex);
    return actFtr.length;
  }

  limitString(content, limit) {
    if (content)
      return content.substring(0, limit) + (content.length >= limit ? '...' : '');
    else
      return '';
  }

  busChargeAmount() {
    var amt = 0;
    for (var i = 0; i < this.users.length; i++) {
      if (this.users[i].eventUser.arriveByPlane)
        amt += (this.users[i].eventUser.busChargePersons * 50);
    }
    return amt;
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/supplier/profile/profile/profile.component.ts